import React, { useMemo } from 'react';
import { GenericListPage } from '../../../components/generic';
import { usePmsEquipmentSystems, PmsEquipmentSystem } from './useData';
import { moduleConfig, getColumns, getToolbarIcon, getTableActions } from './config';

const List: React.FC = () => {
  const config = useMemo(
    () => ({
      ...moduleConfig,
      getColumns,
      getToolbarIcon,
      getTableActions,
    }),
    [],
  );
  return <GenericListPage<PmsEquipmentSystem> useData={usePmsEquipmentSystems} config={config} />;
};

export default List;
